<script>
  import { fly } from "svelte/transition";
  import { flip } from "svelte/animate";
  import { onDestroy } from "svelte";
  import { elasticOut } from "svelte/easing";
  export let userName = "";
  export let userSurName = "";
  export let userRegion = "";
  export let userPhone = "";
  export let userAge = "";
  export let userEmail = "";
  export let userImg = "";
  let show = true;

  onDestroy(() => {
    show = false;
  });
</script>

<style>
  .contact-card {
    width: 100%;
    border: 1px solid var(--white);
    background: linear-gradient(
      140deg,
      var(--primary-color-dark) 0%,
      var(--primary-color-light) 50%,
      var(--primary-color-light) 50%,
      var(--primary-color-dark) 100%
    );
    border-radius: 3px;
    display: flex;
    padding: 1rem;
    flex-wrap: wrap;
    font-size: 1.6rem;
    color: var(--white);
    margin-bottom: 1.5rem;
    cursor: pointer;
  }

  .contact-name {
    display: flex;
    flex: 1 0 90%;
  }

  .contact-region {
    flex: 1 0 10%;
  }

  .contact-phone {
    flex: 1 0 100%;
    margin-top: 1rem;
  }

  .surname {
    margin-left: 0.5rem;
  }

  .extra-info {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .contact-card {
      background: linear-gradient(
        140deg,
        var(--primary-color) 0%,
        var(--primary-color-dark) 50%,
        var(--primary-color-dark) 50%,
        var(--primary-color) 100%
      );
    }

    .contact-name,
    .contact-region,
    .contact-phone {
      flex: 1 0 100%;
      margin-top: 1rem;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

  @media only screen and (max-width: 330px) {
    .contact-name,
    .contact-region,
    .contact-phone {
      margin: 1rem 0;
    }
  }
</style>

{#if show}
  <div class="contact-card" transition:fly={{ y: 500, duration: 500 }}>
    <div class="contact-name">
      <p class="name">{userName}</p>
      <p class="surname">{userSurName}</p>
    </div>
    <div class="contact-region">
      <p class="region">{userRegion}</p>
    </div>
    <div class="contact-phone">
      <p class="phone">Phone: {userPhone}</p>
    </div>

    <div class="extra-info">
      <p data-img={userImg} data-email={userEmail} data-age={userAge} />
    </div>
  </div>

{/if}
